import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Header } from '@/components/generals/header'
import { Footer } from '@/components/generals/footer'

export const Layout: FC<LayoutProps> = ({ children, hideFooter = false }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <Header />

            <main id='main' className='flex-1 overflow-x-clip'>
                {children}
            </main>

            {!hideFooter && <Footer />}
        </div>
    )
}
